import { useEffect, useState } from "react";
import { currentSurahNum,isMediaPlayerPlaying } from "../../stores/sessionStore";
import { useStore } from "@nanostores/react";

const SurahTile=({surah, onClickFunc})=>{
    const [isPlaying,setIsPlaying]=useState(false);
    const surahIdStore=useStore(currentSurahNum);
    const playbackStatus=useStore(isMediaPlayerPlaying);

    const handlePlaybackState=()=>{
        if(surahIdStore===Number(surah.index))
        {
            setIsPlaying(true);
        }
        else
        {
            setIsPlaying(false);
        }
    }

    useEffect(()=>{
        handlePlaybackState();
    },[surahIdStore]);

    return(
        <div className="col-span-12 md:col-span-6 lg:col-span-4 blue-gr-box p-5 search alim-interactive-tile cursor-pointer" onClick={onClickFunc}>
            <div className="grid grid-cols-8 items-center gap-2">
                <div className="col-span-2 flex justify-center items-center bg-deep-red rounded text-white text-opacity-70 dark:text-opacity-100 text-base w-12 h-10 -rotate-45">
                    <p className="rotate-45 flex justify-center items-center">
                        {
                            // isPlaying?
                            //     <img src="/images/media-player/pause.svg" width="15" height="20" alt="Pause button" className="min-w-[15px] cursor-pointer"/>
                            // :
                            //     <img src="/images/media-player/play.svg" width="15" height="20" alt="Play button" className="min-w-[15px] cursor-pointer"/>
                            
                        }
                        <span id="play-button-container">
                            <span className={`play-button play-button-before ${isPlaying&&playbackStatus?`playing`:``}`}></span>
                            <span className={`play-button play-button-after ${isPlaying&&playbackStatus?`playing`:``}`}></span>
                        </span>
                    </p>
                </div>
                <div className="col-span-4">
                    <p className="alim-font-color-style text-sm truncate" title={surah.title}>{Number(surah.index)}. {surah.title}</p>
                    <p className="text-sm text-deep-grey truncate" title={surah.title}>{surah.titleEn}</p>
                </div>
                <div className="col-span-2 text-right">
                    <p className="alim-font-color-style text-sm hover:text-deep-red cursor-pointer">Juz {surah.juz[0].index}</p>
                    <p className="text-sm text-deep-grey">{surah.count} Ayahs</p>
                </div>
            </div>
        </div>
    );
}

export default SurahTile;